module.exports = __webpack_public_path__ + "img/en_gb.a0c39ec6.svg";